var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92193,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_1876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.521 28.6569V33.3482C37.521 34.7189 36.4082 35.8326 35.0366 35.8326H13.8672C12.4956 35.8326 11.3828 34.7189 11.3828 33.3482V16.4249C11.3828 15.0532 12.4965 13.9404 13.8672 13.9404H35.0366C36.4082 13.9404 37.521 15.0541 37.521 16.4249V21.1162H31.5545C29.4734 21.1162 27.7841 22.8055 27.7841 24.8865C27.7841 26.9676 29.4734 28.6569 31.5545 28.6569H37.521Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.954 26.1693C33.6625 25.4608 33.6625 24.3121 32.954 23.6036C32.2455 22.8951 31.0968 22.8951 30.3883 23.6036C29.6798 24.3121 29.6798 25.4608 30.3883 26.1693C31.0968 26.8778 32.2455 26.8778 32.954 26.1693Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_1876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.566,
    height: 23.32,
    fill: "white",
    transform: "translate(10.668 13.2266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuWallet);
export default __webpack_public_path__ + "static/media/icon_menu_wallet.05e7910ac7d69a9a0921e8f118d1fea0.svg";
export { ForwardRef as ReactComponent };